import React, {useEffect} from 'react';
import {Helmet} from "react-helmet";
import {
  Link,
} from "react-router-dom";

import {connect} from 'react-redux';
import {Actions as PAYMENTACTIONS} from '../store/actions/paymentActions';

import PayAndRegister from '../components/common/PayAndRegister'
import FeaturesSideBySide from '../components/features/FeaturesSideBySide'
import MaltaFeatures from '../components/features/MaltaFeatures'
import Team from '../components/team/Team'
import Pricing from '../components/pricing/Pricing'
import Testimonials from '../components/testimonials/Testimonials'
import Security from '../components/security/Security'


import MaltaFlag from '../assets/flags/malta.svg';

import mcDonaldsLogo from '../assets/images/mc-donalds.png';
import sixteenLogo from '../assets/images/sixteen.png';
import myokaLogo from '../assets/images/myoka.png';
import skySpiritLogo from '../assets/images/sky-spirit.png';


function Home({
  selectBundle,
  getBundles,
  bundles
}) {

  useEffect(() => {
    getBundles()
  },[]);


  useEffect(() => {
    if (bundles){
      selectBundle(bundles.find(item => item.name == "250 Credits"))
    }
  },[bundles]);

  return (

    <React.Fragment>
      <main className="mt-8 sm:mt-16 md:mt-20 lg:mb-24 mb-8 sm:mb-16 md:mb-20 lg:mb-24">
        <div className="mx-auto max-w-screen-xl">
          <div className="lg:grid lg:grid-cols-12 lg:gap-8">
            <div className="px-4 sm:px-6 sm:text-center md:max-w-2xl md:mx-auto lg:col-span-6 lg:text-left lg:flex lg:items-center">
              <div>
                
                <h1 className="mt-4 text-4xl tracking-tight leading-10 font-extrabold text-white sm:mt-5 sm:leading-none sm:text-6xl lg:mt-6 lg:text-5xl xl:text-6xl">
                  Covid-19
                  <br className="hidden md:inline"/>
                  <span className="text-orange-400">Payroll Support</span>
                </h1>
                <p className="mt-3 text-base text-gray-300 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl">
                  Struggling to make ends meet due to Covid-19?
                  All businesses on Annex A are eligible for one-time unlimited employee payroll for 2021.
                  Pay for your first 250 credits, the rest is on us.
                  <small>Offer Valid until 31 December 2020</small>
                </p>
                <p className="mt-8 text-sm text-white uppercase tracking-wide font-semibold sm:mt-10">Used by</p>
                <div className="mt-5 w-full sm:mx-auto sm:max-w-lg lg:ml-0">
                  <div className="flex flex-wrap items-start justify-between">
                    <div className="flex justify-center px-1">
                      <img className="h-9 sm:h-10" src={sixteenLogo} alt="Mc Donalds"/>
                    </div>
                    <div className="flex justify-center px-1">
                      <img className="h-9 sm:h-10" src={myokaLogo} alt="Myoka Spas"/>
                    </div>
                    <div className="flex justify-center px-1">
                      <img className="h-9 sm:h-10" src={skySpiritLogo} alt="Sky Spirit"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-12 sm:mt-16 lg:mt-0 lg:col-span-6">
              <PayAndRegister specialTerms="This offer is only available to businesses which can be found on Annex A of the Malta Enterprise Support Measures."/>
            </div>
          </div>
        </div>
      </main>

      <FeaturesSideBySide/>
      <MaltaFeatures/>
      <Pricing/>
      <Testimonials/>
      <Security/>
      <Team/>

    </React.Fragment>
    
  );
}

const mapStateToProps = (state) => {

  return {
    bundles: state.payment.bundles
  }
}

const mapDispatchToProps = dispatch => ({
  selectBundle: (bundle) => dispatch(PAYMENTACTIONS.selectBundle(bundle)),
  getBundles: () => dispatch(PAYMENTACTIONS.getBundles()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Home) 
